const Selectors = {
  widget: {
    target: ".booking-section-wrap",
    waitFor: ".booking-section-wrap",
    mobileWidgetTarget: ".booking-section-wrap",
    mobileWidgetFixedTarget: "body", //".azds-contact-block", //"boutique-review-info",
    widgetDesktop: "#gustbook-widget-desktop",
    widget: "#guestbook-widget",
    stickyWidget: "#guestbook-sticky-widget",
  },
  ratesPage: {
    waitFor: ".room .room-main-info .room-info, .step-2-rates .extra-descr .clearfix",
    contentChangeTarget: "#spinner, boutique-room",
    rates: "extension-point .current-price, extension-point .price",
    ratesCodes: "NA",
    ratesMessage: ".gb-rates-message", 
    currency: "extension-point[name='rate-price'] .current-price",
  },
  paymentPage: {
    waitFor: "#Express-BookNow-Button, button.btn-step-3-complete.reserve-btn",
    contentChangeTarget: "#sb-express-terms-inject-bottom, #sb-express-terms-inject-top",
    currency: ".taxes-and-fees",
    checkin: "NA",
    checkout: "NA",
    cartTarget: "NA",
    firstname: "#pay-by-card-first-name, #firstName_0",
    lastname: "#pay-by-card-last-name, #lastName_0",
    email: "#pay-by-card-email, #email_0",
    subtotal: "boutique-review-charge > div > div:nth-child(1) > div.col-r > span",
    total: "boutique-review-charge > div > div:nth-child(3) > div.col-r > span",
    enrollmentTarget: ".reserve-form .title",
    saveInfoTarget: "#Express-BookNow-Button, .google-pay-button-container",
    enrollmentMessageContainer: "#guestbook-enrollment",
  },
  confirmationPage: {
    waitFor: [
      ".azds-reservation-number",
      {
        type: "WINDOW_VAR_EXISTS",
        script:
          "var val = window.data; script.setAttribute('data-val', val);",
      },
    ],
    messageTarget: "boutique-reservation-overview",
    name: "div.booking-confirmation-info-container > div > div.section-cols.clearfix > div:nth-child(1) > div.value",
    email: "div.booking-confirmation-info-container > div > div.section-cols.clearfix > div:nth-child(4) > div.value",
    confirmationNumbers: ".azds-reservation-number",
    contentChangeTarget: "NA",
    confirmationMessageContainer: "#guestbook-confirm",
  },
  cancellation: {
    waitFor: ".cancel-reservation-cancellation",
    confirmationNumber: "input#reservationId",
  }
};

export default Selectors;
